/**
 * Facets pills for product list
 */

import './_facets-pills.twig';
import './_facets-pills.scss';
import 'jquery.sticky';

export const name = 'facets-pills';

export function disable() {}

/**
 * Enables this component.
 *
 * @param {jQuery} $context - A piece of DOM
 */
(function ($, Drupal, $context) {
  // Find our component within the DOM
  const $facets = $('ul.facets', $context);
  const $facetsPills = $('ul.facets-pills', $context);
  // Bail if component does not exist
  if (!$facets.length || !$facetsPills.length) {
    return;
  }
  $facetsPills.find('.facets-pills__pill a').click(function handler() {
    const id = $(this).data('facet-id');
    $(`#${id}`).unbind('change').removeAttr('checked');
    $facets.find('.facet-item-child__checkbox').attr('disabled', 'disabled');
  });

  const handler = (system) => {
    $facetsPills.find(`.${system.previous}`).hide();
    $facetsPills.find(`.${system.current}`).show();
  };
  if (Drupal.behaviors.measurementSystemToggle) {
    Drupal.behaviors.measurementSystemToggle.onChange(handler);
  } else {
    document.addEventListener('MeasurementSystemToggleReady', function fn(e) {
      e.detail.toggle.onChange(handler);
    });
  }
  // Expands and collapses facet pills on click.
  const viewAllToggle = $('.facets-pills__expand', $context);

  // For mobile show 4 pills,
  // For desktop show 6 pills.
  let maxPills = 6;
  if ($(window).width() < 719) {
    maxPills = 4;
  }

  if ($facetsPills.find('li').length > maxPills) {
    viewAllToggle.parent().removeClass('d-none');
  }
  $facetsPills.find('li').slice(0, maxPills).removeClass('d-none');

  viewAllToggle.on('click', () => {
    const $el = $('.view-filters');
    $facetsPills
      .find('li')
      .slice(maxPills, $facetsPills.find('li').length)
      .toggleClass('d-none');
    viewAllToggle.toggleClass('facets-pills__active');
    // eslint-disable-next-line no-unused-expressions
    viewAllToggle.hasClass('facets-pills__active')
      ? $el.text(Drupal.t('View All Filters'))
      : $el.text(Drupal.t('View Less Filters'));
  });
})(jQuery, Drupal);
